import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-navy-light py-20 px-4 border-t border-white/5" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="flex items-center gap-3 mb-8" data-id="element-125">
          <AlertTriangle className="w-8 h-8 text-danger" data-id="element-126" />
          <h2 className="text-2xl md:text-3xl font-headline font-bold text-white uppercase tracking-wide" data-id="element-127">
            Section 1: The Reality Check
          </h2>
        </div>

        <div className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-128">
          <p data-id="element-129">
            If you're a parent with a kid between 8 and 16 years old who{' '}
            <span className="text-white font-bold" data-id="element-130">"crushes it"</span> on the
            field, you've probably felt this knot in your stomach:
          </p>

          <div className="bg-navy p-6 rounded-lg border-l-4 border-danger/70 shadow-lg" data-id="element-131">
            <p className="italic text-gray-200" data-id="element-132">
              "You see kids with half the talent of your child, but with parents
              who have better connections or bigger checkbooks, taking the
              starting spots on the best teams."
            </p>
          </div>

          <p data-id="element-133">
            You watch your kid put in the effort every practice, only to remain
            stuck at the "Recreational" level or in a local academy where the
            coach only knows your kid's name when it's time to pay the fee.
          </p>

          <p className="font-bold text-white text-xl md:text-2xl border-b border-danger/30 pb-4 inline-block" data-id="element-134">
            I have a bitter truth for you:
          </p>

          <p data-id="element-135">
            In the United States, soccer is not a game of "luck."{' '}
            <span className="text-danger font-bold" data-id="element-136">
              It's a pay-for-visibility system.
            </span>{' '}
            If you don't know the secret metrics that scouts write down in their
            notebooks, your kid will remain a "silent talent" until it's too
            late.
          </p>
        </div>
      </div>
    </section>;
}